import { SortDescriptor } from '@progress/kendo-data-query'
import {
  IntroducingBrokerProfileFilterKey,
  IntroducingBrokerProfileKey,
} from 'api/Trading-Accounts/Types/IntroducingBrokerProfileDto'

export const normalizeIntroducingBrokerProfilesSortQuery = (
  sortDescriptors: SortDescriptor[]
): SortDescriptor[] =>
  sortDescriptors
    .map((x) => {
      if (x.field === IntroducingBrokerProfileKey.name) {
        return { ...x, field: IntroducingBrokerProfileFilterKey.name }
      }
      if (x.field === IntroducingBrokerProfileKey.tickmillCompany) {
        return { ...x, field: IntroducingBrokerProfileFilterKey.tickmillCompany }
      }
      return x
    })
    .filter((x) => !!x)
